import { cn } from '@/lib/utils';
import logoImg from '@/assets/img/logo.png';
import onlyKImg from '@/assets/img/onlyK.png';

interface BrandLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | number;
  animate?: boolean;
  collapsed?: boolean;
}

const BrandLogo = ({
  className,
  size = 'md',
  animate = false,
  collapsed = false,
}: BrandLogoProps) => {
  const sizeMap = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-14 h-14',
    xl: 'w-32 h-32',
  };

  const sizeClass = typeof size === 'number' ? '' : sizeMap[size];
  const customStyle = typeof size === 'number' ? { width: size, height: size } : {};

  return (
    <div
      className={cn(
        'relative flex items-center justify-center shrink-0 overflow-hidden rounded-xl',
        animate && 'animate-pulse',
        sizeClass,
        className,
      )}
      style={customStyle}
    >
      <img
        src={collapsed ? onlyKImg : logoImg}
        alt="Kipi Logo"
        className="w-full h-full object-contain"
      />
    </div>
  );
};

export default BrandLogo;
